import { labelService } from '@/utils/labels';
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('tenant', ['tenant']),

		labels() {
			const tenantId = this.getTenantId();
			return labelService.getLabels(tenantId);
		},
	},

	methods: {
		getTenantId() {
			return this.tenant?.tenantId || this.$store.getters.user?.['custom:tenant'];
		},

		getLabel(labelKey, defaultValue = '') {
			return labelService.getLabel(this.getTenantId(), labelKey, defaultValue);
		},

		formatLabel(labelKey, replacements = {}, defaultValue = '') {
			const label = this.getLabel(labelKey, defaultValue);
			return labelService.formatLabel(label, replacements);
		},
	},
};
